<template>
  <div class="main" >
    <span class="main-config">
      <div v-if="!readOnly" class="ml-2 mr-2 mb-2 mt-2">
        <label>{{ $t('operacoes') }} </label>
        <b-form-select
          class="input-pentagro"
          v-model="operationSelected"
          :options="operations"
        ></b-form-select>
      </div>
      <b-form v-if="operationSelected" class="b-layout">
        <div>
          <b-card v-if="equipments.length > 0">
            <div v-for="(prop, index) in equipments" :key="prop.caption + index">
              <b-form-checkbox
                class="switch-item"
                v-model="prop.value"
                @change="ChangeOnOff($event, prop)"
                switch
                >
                {{ prop.equipName }}
              </b-form-checkbox>
            </div>
          </b-card>
          <div v-else>
            <b-card v-if="!this.node.readOnly" >
                <label class="noOperationfield">{{ $t('operacao-sem-equipamentos') }}</label>
            </b-card>
          </div>
        </div>
        <div class="ml-3">
          <b-card>
            <div v-if="capacidade" class="inp mb-2">
              <label>{{ $t('capacidade-m-h') }} </label>
              <label class="input-data">{{ capacidade.value | ParseNumber }}</label>
            </div>
            <div class="inp" v-if="Ocupacao">
              <label>{{ $t('ocupacao-0') }} </label>
              <label class="input-data">{{ Ocupacao.value | ParseNumber }}</label>
            </div>
          </b-card>
        </div>
      </b-form>
    </span>
    <div v-if="jokerEquipmentList.length" class="joker">
      <label class="mt-2 ml-2">{{ $t('equipamentos-coringas') }}</label>
      <div v-for="(joker, i) in jokerEquipmentList" :key="i">
        <b-form>
          <div class="ml-2 mr-2">
            <TextToInput 
              :text="joker.caption"
              @sendText="updateCaption($event, joker)">
            </TextToInput>
          </div>
          <span class="b-layout">
            <b-card v-if="equipments.length > 0">
              <div v-for="(prop, index) in joker.equipments" :key="prop.caption + index">
                <b-form-checkbox
                  class="switch-item"
                  v-model="prop.value"
                  @change="ChangeOnOffJoker($event, prop, equipments, joker)"
                  switch
                  >
                  {{ prop.equipName }}
                </b-form-checkbox>
              </div>
            </b-card>
            <div class="ml-3" v-if="equipments.length > 0">
              <b-card>
                <div class="inp mb-2">
                  <label>{{ $t('capacidade-m-h') }} </label>
                  <label class="input-data" >{{ joker.capacidade.value | ParseNumber }}</label>
                </div>
                <div class="inp">
                  <label>{{ $t('ocupacao-0') }} </label>
                  <label class="input-data">{{ joker.Ocupacao.value | ParseNumber }}</label>
                </div>
              </b-card>
            </div>
          </span>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";
import { SingletonAreas } from '../_service/singletonAreas';
import { JokerEquipmentMixin } from '../../../mixins/jokerEquipmentsMixin'
import { FiltersMixin }  from '../../../mixins/filtersMixin'
import TextToInput from "../../../template/TextToInput"

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  components: { TextToInput },

  mixins: [ JokerEquipmentMixin, FiltersMixin ],

  data() {
    return {
      currentArea: SingletonAreas.currentArea,
      attrList: ["capacidade", "Ocupacao"],
      capacidade: {},
      Ocupacao: {},
      operations: [{ value: null, text:this.$t('selecione-uma-operacao') }],
      operationSelected: null,
      operationAttributeList: [],
      firstLoad: false,
      equipments: [],
      equipCap: [],
    };
  },

  watch: {
    operationSelected(value) {
      if (this.firstLoad || !value) {
        this.firstLoad = false;
        return;
      }

      this.buildJokerEquipment(value)
      
      this.operationAttributeList = SingletonEnginnering.getOperationsProperties(this.operationSelected)
      .filter((operation) => this.attrList.includes(operation.key));
      
      if (this.equipments.length > 0) {
        this.capacidade = this.operationAttributeList.find(
          (p) => this.attrList[0] == p.caption
          );
        }
        
        this.Ocupacao = this.operationAttributeList.find(
          (p) => this.attrList[1] == p.caption
          );
          
          if (this.capacidade)
          this.capacidade.value =
        this.equipments.length > 0 ? ParseToNumber(this.capacidade.value) : "";
        if (this.Ocupacao)
        this.Ocupacao.value = isNaN(parseFloat(this.Ocupacao.value))
          ? ""
          : ParseToNumber(this.Ocupacao.value);
          
        this.loadEquipments();
        this.updateNode();
    },

    "capacidade.value"() {
      this.updateNode();
    },

    "Ocupacao.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data.length > 0) {
        if (this.node.data[0].index) {
          this.buildJokerEquipment(this.node.data[0].index, this.node.jokerCaption)
          this.firstLoad = true;
          this.operationSelected = this.node.data[0].index;
          this.loadNotInput();
        }
      }

      this.equipments = new Array();
      
      this.node.data.forEach((p) => {
        if (p.equipName) {
          let equip = p.clone();
          equip.value = parseInt(equip.value) ? true : false;
          
          this.equipments.push(equip);
        }
      });
      this.loadEquipments();
    },

    loadNotInput() {
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = ["capacidade", "Ocupacao"];
      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );

        if (this.capacidade && attrName == "capacidade")
          this.capacidade.value =
            this.equipments.length > 0 ? ParseToNumber(this.capacidade.value) : "";
        if (this.Ocupacao && attrName == "Ocupacao")
          this.Ocupacao.value = isNaN(parseFloat(this.Ocupacao.value))
            ? ""
            : ParseToNumber(this.Ocupacao.value);
      });
    },

    updateCaption(caption, joker){
      joker.caption = caption
      this.updateNode();
    },

    updateNode() {
      let attrs = [];

      if(this.equipments && this.equipments.length){
        this.equipments.forEach((e) => {
          let prop = e.clone();
          prop.value = e.value ? "1,00" : "0,00";
          attrs.push(prop);
        });
        this.node.attrs = attrs;
        this.updateJokerNode(this.node, this.jokerEquipmentList)
      }
    },

    loadEquipments() {
      let equipsName = SingletonEnginnering.getOperationsEquipments(
        this.operationSelected
      );

      let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(
        this.operationSelected
      );
      let auxEquipment = new Array();

      equipsName.forEach((e) => {
        let props = propsByEquipment[e];
        Object.keys(props).forEach((p) => {
          if (props[p].caption == "Status") {
            props[p].value = parseInt(props[p].value) ? true : false;
            auxEquipment.push(props[p]);
          }
          if (props[p].caption == "Capacidade") {
            if (props[p].strValue != "") {
              props[p].value = props[p].strValue;
            }
            this.equipCap.push(props[p]);
          }
        });
      });
      this.equipments = auxEquipment;
    },

    ChangeOnOff(event, prop) {
      prop.value = event;
      this.Changecapacidade();
      this.switchStatusJoker(prop, this.equipments, false, this.Changecapacidade)
      this.updateNode();
    },

    Changecapacidade() {
      if (this.capacidade) {
        this.capacidade.value = 0;
        this.equipments.forEach((e) => {
          let cap = this.equipCap.find((c) => c.equipName == e.equipName);
          if (e.value && cap)
            this.capacidade.value += parseFloat(String(cap.value).replace(",", "."));
        });
      }
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) => o.match(/Bomba/));
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
    this.Changecapacidade();
    this.changeExternalCapacity = function () { this.Changecapacidade() }
    this.updataNodeInMixin = function () { this.updateNode() }
  },
};
</script>

<style scoped>
.main{
  display: flex;
}

.main-config,
.joker {
  width: 500px;
  height: 350px;
  overflow-y: auto;
}

.width-155{
  width: 155px;
}

.input-data{
  width: 70px;
  text-align: right;
}

form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

input {
  margin-left: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.noOperationfield{
  width: 155px;
  text-align: center;
}

</style>